<template>
    <v-container>
        <v-flex class="text-start">
            <h2 style="color: #DC8E28; background-color: #F5F5F5;">VSS Portal</h2>
        </v-flex>
        <v-flex mt-10>
            <v-flex>
                <p>You are currently on the VSS online Portal webpage. This is the site to use to request a certified copy of a vital record certificate to be mailed to you. This is also the site to fill out worksheets for expectant mothers, and worksheets for marriage applicants.</p>
                <ul>
                    <li>
                        <p>Be sure to allow cookies and pop ups for this webpage.</p>
                    </li>
                    <li>
                        <p>You will be required to upload an image of a valid government issued ID to complete your request.</p>
                    </li>
                    <li>
                        <p>If you have not used our Portal before, you will need to click the <span style="color:#E48E1A;">top left tribar menu icon</span>, then on Log in on the expanded side bar to start. You must create an online profile (click Sign up in the login window) before you are able to log in and place an order. Choose either Google authentication, or enter an email and password, then go to your email to click the verification link. Then, log in to Portal.</p>
                    </li>
                </ul>
            </v-flex>
            <v-flex mt-10>
                <p>Certificate Orders</p>
                <ul>
                    <li>
                        <p>Once you are logged into Portal, select the type of certificate you wish to request. Be sure to enter information in all of the required fields.</p>
                    </li>
                    <li>
                        <p>Certificate orders placed online must be paid by credit card. Please know that there will be a 2.4%, $1.00 minimum convenience fee charged for every order placed.</p>
                    </li>
                    <li>
                        <p>If you would like to have your certificate sent back to you by means other than USPS First Class Mail, you may attach a pre-paid label to your certificate order. You would purchase the label from your desired service (UPS, FedEx, USPS), receive the label, then upload the electronic label to your order (in the ID image upload section) for our office to attach to your certificate mailing. The label should list your address as both the sender and the addressee.</p>
                    </li>
                    <li>
                        <p>You will be required to attach an image of a valid government issued ID before your order can be processed. If you do not have a valid government ID, please contact our office at 307-777-7591 for more information on how you will be able to obtain your certificate.</p>
                    </li>
                    <li>
                        <p>If your certificate request is missing required details or needs additional information, VSS will contact you through your Portal Inbox, which is visible in the left menu once you create your online profile in the Portal. You will need to respond to requests for information within 15 days. Requestors who do not respond in a timely manner will have their requests canceled. Any fees paid for an order that is canceled cannot be refunded.</p>
                    </li>
                    <li>
                        <p>If you are unable to use our online Portal ordering system, you may send your request to us through the mail: <a href="https://health.wyo.gov/admin/vitalstatistics/certificates/#mailcert" target="_blank">How to Request a Certified Copy of a Certificate through the Mail</a>. (This link takes you to the Department of Health website where you may download the certificate ordering forms to use via mail service.)</p>
                    </li>
                </ul>
            </v-flex>
            <v-flex mt-10>
                <p>Worksheets</p>
                <ul>
                    <li>
                        <p>New mothers may complete the mother’s worksheet which will provide the information used by your birth facility to create your child’s birth certificate.</p>
                    </li>
                    <li>
                        <p>Marriage applicants may complete a marriage worksheet online, which will provide the information used by your County Clerk to create your marriage license application.</p>
                    </li>
                    <li>
                        <p>If you are completing a worksheet, you must create an account and Log In. There is no fee for worksheets.</p>
                    </li>
                </ul>
            </v-flex>
            <v-flex mt-10>
                <p>If you have read this page and have further questions please contact our office at 307-777-7591 so we may assist you.</p>
            </v-flex>
        </v-flex>
    </v-container>
</template>

<script>
export default {
    name: 'certificate-instructions'
}
</script>

<style scoped>
    p, b {
        font-size: large !important;
    }
    ul {
        margin-left: 23px;
        margin-right: 23px;
    }
</style>
